import { render, staticRenderFns } from "./viewOfficers.vue?vue&type=template&id=7ddc3681"
import script from "./viewOfficers.vue?vue&type=script&lang=js"
export * from "./viewOfficers.vue?vue&type=script&lang=js"
import style0 from "./viewOfficers.vue?vue&type=style&index=0&id=7ddc3681&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports